'use strict';
import angular from 'angular';
const _ = require('lodash');
import uiRouter from 'angular-ui-router';

import routes from './bhired_candidate.routes';
/**
  * @class angular_module.bhired_candidateComponent
  */
export class bhired_candidateComponent {
     /*@ngInject*/
     constructor($http, $scope, $uibModal, Modal) {
          this.$http = $http;
          this.$uibModal = $uibModal;
          this.pageSize = 50;
          this.showAll = false;
          this.scores = [];
          this.candidates = [];
          this.hideToggleButtonOption = false;
          this.deletecandidate = Modal.confirm.delete(candidate => {
               $http.delete(`/bhired_api/candidate/${candidate._id}`).then(() => this.getcandidates(50));
          });
     }
     respondWithResult(res, statusCode) {
          statusCode = statusCode || 200;
          return function (entity) {
               if (entity) {
                    return res.status(statusCode).json(entity);
               }
               return null;
          };
     }

     reprocessUserScore(email) {
          this.$http.put('/bhired_api/candidate/reprocessallscores/'+email)
          .then( response =>{
               this.success="Data Successfully Processed for "+email;
          });
     }

     /**
	* @function getcandidates
     * @memberOf angular_module.bhired_candidateComponent
     * @param {Number}itemCount - candidate count
     * @description this function calls bhired candidates api to get bhired candidates.
	*/
     getcandidates(itemCount) {
          this.$http.get('/bhired_api/candidate/' + itemCount)
               .then(response => {
                    this.refresh = false;
                    // this.candidates = _.concat(this.candidates, response.data);
                    this.candidates = response.data;
                    this.candidates.forEach(candidate => {
                         candidate['game_overall_status'] = 'incomplete';
                         for(var game = 0 ; game < candidate['gameInfo'].length;game++){
                              if(candidate['gameInfo'][game]['game_status'] === 'complete'){
                                   candidate['game_overall_status'] = 'complete';
                                   break;
                              }  
                         }
                         // candidate['gameInfo'].forEach(game => {
                         //      candidate['game_overall_status'] = 'incomplete';
                         //      if(game['game_status'] === 'complete'){
                         //           candidate['game_overall_status'] = 'complete';
                         //      }
                         // });
                    });
                    
                    if (response.data.length >= 50) {
                         this.hideToggleButtonOption = true;
                    } else {
                         this.hideToggleButtonOption = false;
                    }
               });
     }

     /**
	* @function $onInit
     * @memberOf angular_module.bhired_candidateComponent
     * @fires getcandidates
     * @description this function intiates the bhiredcandidate component.
	*/
     $onInit() {
          this.getcandidates(50);
     }

     /**
	* @function showToggle
     * @memberOf angular_module.bhired_candidateComponent
     * @fires getcandidates
     * @description this function is used to showToggle.
	*/
     showToggle() {
          this.refresh = true;
          this.pageSize += 50;
          this.getcandidates(this.pageSize);
     }
}

export default angular.module('leafApp.bhired_candidate', [uiRouter])
     .config(routes)
     .component('bctab', {
          template: require('./bhired_candidate.html').default,
          controller: bhired_candidateComponent,
          controllerAs: 'bhired_candidateCtrl'
     })
     .name;